import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FoundationLocaleSelectModule } from "../locale-select/locale-select.module";
import { FoundationPracticeSelectModule } from "../practice-select/practice-select.module";
import { FoundationHeaderComponent } from "./header.component";

@NgModule({
  declarations: [FoundationHeaderComponent],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatMenuModule,
    MatIconModule,
    FoundationPracticeSelectModule,
    FoundationLocaleSelectModule,
    MatButtonModule,
  ],
  exports: [FoundationHeaderComponent],
})
export class FoundationHeaderModule {}
